import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/mav-enforcement`;

export const mavEnforcementService = {
  async evaluateEmission(data) {
    const response = await axios.post(`${API_BASE}/evaluate`, data);
    return response.data;
  },

  async listDistributions(filters = {}) {
    const params = new URLSearchParams();
    if (filters.product_category) params.append('product_category', filters.product_category);
    if (filters.region) params.append('region', filters.region);
    const query = params.toString();
    const response = await axios.get(`${API_BASE}/distributions${query ? `?${query}` : ''}`);
    return response.data;
  },

  async getDistribution(id) {
    const response = await axios.get(`${API_BASE}/distributions/${id}`);
    return response.data;
  },

  async upsertDistribution(data) {
    const response = await axios.post(`${API_BASE}/distributions`, data);
    return response.data;
  },

  async advancePhase(id) {
    const response = await axios.post(`${API_BASE}/distributions/${id}/advance-phase`);
    return response.data;
  },
};

export default mavEnforcementService;
